import React, { useState, useEffect, useCallback } from 'react';
import { createClient } from '@supabase/supabase-js';
import { supabaseUrl, supabaseKey } from '../config.ts';

const supabase = createClient(supabaseUrl, supabaseKey);

const OutGallery = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [loadingGallery, setLoadingGallery] = useState(true);
  const [uploadError, setUploadError] = useState(null);
  const [showModal, setShowModal] = useState(false); // New state for modal visibility
  const [selectedImage, setSelectedImage] = useState(null); // New state for selected image

  const fetchGalleryImages = useCallback(async () => {
    setLoadingGallery(true);
    setUploadError(null);
    try {
      const { data, error } = await supabase.storage.from('gallery').list('', {
        limit: 100,
        offset: 0,
        sortBy: { column: 'created_at', order: 'desc' },
      });

      if (error) {
        throw error;
      }

      const imageUrls = data
        .filter(file => file.name !== '.emptyFolderPlaceholder')
        .map(file => ({
          name: file.name,
          url: supabase.storage.from('gallery').getPublicUrl(file.name).data.publicUrl,
        }));
      setGalleryImages(imageUrls);
    } catch (error) {
      console.error('Error fetching gallery images:', error.message);
      setUploadError('Failed to load gallery images.');
    } finally {
      setLoadingGallery(false);
    }
  }, []);

  useEffect(() => {
    fetchGalleryImages();
  }, [fetchGalleryImages]);

  // Function to handle image click and open modal
  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  // Function to handle modal close
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <ul className="breadcrumb-animation">
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
        </ul>
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h3 className="display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">
            Our Gallery
          </h3>
          <ol
            className="breadcrumb justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          >
            <li className="breadcrumb-item">
              <a href="/">Home</a>
            </li>
            <li className="breadcrumb-item active text-primary">Gallery</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* Gallery Content Start */}
      <div className="container py-5">
        <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: 900 }}>
          <h4 className="text-primary mb-4">Our Projects</h4>
          <h1 className="display-5 mb-4">Explore Our Completed Works</h1>
          <p className="lead text-muted mb-0">
            Take a look at some of our successful projects and the quality of our craftsmanship.
          </p>
        </div>
        <div className="row g-4">
          {loadingGallery ? (
            <div className="col-12 text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading gallery images...</p>
            </div>
          ) : uploadError ? (
            <div className="col-12 text-center">
              <div className="alert alert-danger" role="alert">
                {uploadError}
              </div>
            </div>
          ) : galleryImages.length > 0 ? (
            galleryImages.map((item) => (
              <div
                key={item.name}
                className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
                data-wow-delay="0.1s"
                onClick={() => handleImageClick(item)} // Add onClick handler
                style={{ cursor: 'pointer' }} // Indicate clickable
              >
                <div className="gallery-item rounded-4 shadow-sm overflow-hidden position-relative">
                  <img src={item.url} className="img-fluid w-100" alt={item.name} style={{ objectFit: 'cover', height: '250px' }} />
                  <div className="gallery-overlay d-flex flex-column justify-content-end p-3">
                    <h5 className="text-white mb-1">{item.name.split('.')[0].replace(/[-_]/g, ' ')}</h5>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <p>No gallery images found.</p>
            </div>
          )}
        </div>
      </div>
      {/* Gallery Content End */}

      {/* Image Modal */}
      {showModal && selectedImage && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 1050 }}
          onClick={handleCloseModal} // Close modal when clicking outside
        >
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document" onClick={e => e.stopPropagation()}> {/* Prevent modal close on content click */}
            <div className="modal-content bg-dark">
              <div className="modal-header border-bottom-0">
                <h5 className="modal-title text-white">{selectedImage.name.split('.')[0].replace(/[-_]/g, ' ')}</h5>
                <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={handleCloseModal}></button>
              </div>
              <div className="modal-body text-center">
                <img src={selectedImage.url} className="img-fluid rounded" alt={selectedImage.name} style={{ maxHeight: '80vh', maxWidth: '100%' }} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OutGallery;